import { thumbHashToDataURL } from 'thumbhash';

const cache = new Map<string, string>();

/** ThumbHash (base64) → PNG data URL for a blurry placeholder; cached, and '' for missing/invalid hashes. */
export function thumbhashDataUrl(hash: string | undefined): string {
  if (!hash) return '';
  const hit = cache.get(hash);
  if (hit !== undefined) return hit;
  let url = '';
  try {
    const bin = atob(hash);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    url = thumbHashToDataURL(bytes);
  } catch {
    url = '';
  }
  if (cache.size > 5000) cache.clear();
  cache.set(hash, url);
  return url;
}
